<!-- <section class="mbr-section mbr-after-navbar" id="form1-1r"
    style="background-color: #f8f9fa; padding-top: 0px; height: 15%;">
    <form>
        <div>
            <mat-list class="mat-list-group">
                <mat-list-item class="mat-list-item-group" *ngFor="let group of makeToOrderGroupList"
                    (click)="onGroupSelect(group.refNo)"
                    [ngClass]="groupClickId == group.refNo ? 'group_active' : 'cell-style'">
                    {{ group.productGroupName }}
                </mat-list-item>
            </mat-list>
        </div>

        <div *ngIf="subGroupShow">
            <mat-list class="mat-list-subgroup">
                <mat-list-item class="mat-list-item-subgroup" *ngFor="let subGroup of subGroupList"
                    (click)="onSubGroupSelect(subGroup.refNo)"
                    [ngClass]="subGroupClickId == subGroup.refNo ? 'group_active' : 'cell-style'">
                    {{ subGroup.productSubGroupName }}
                </mat-list-item>
            </mat-list>
        </div>
    </form>
</section> -->

<div class="div-display">
    <div [ngClass]="openfilter ? 'system-view': 'system-view display_none_small'" *ngIf="show">
        <div class="filter-sidebar">
            <div class="filter-header">
                <h3><i class="fa fa-filter"></i> Filters</h3>
                <h3 *ngIf="selectedFilters.showClearAll" class="h3_clear_all" (click)="clearAllFilters()">Clear All</h3>
            </div>
            <div class="selected-filters">
                <!-- <div *ngFor="let filter of selectedFilters">
                    <span>{{ filter }}</span>
                    <button (click)="removeFilter(filter)">x</button>
                </div> -->
            </div>
            <form [formGroup]="searchForm">
                <!-- Price Filter -->
                <div class="filter-section">
                    <h3 class="section-header" (click)="toggleSection('price')">
                        Price Range
                        <i class="arrow-icon" [ngClass]="isCollapsed.price ? 'fa fa-angle-down' : 'fa fa-angle-up'"></i>
                    </h3>

                    <div *ngIf="!isCollapsed.price" class="price-filter-body">
                        <!-- SLIDER -->
                        <div class="range-slider">

                            <div class="slider-track"></div>

                            <div class="slider-range"
                                [style.left.%]="((searchForm.get('minValue')?.value - globalMin) / (globalMax - globalMin)) * 100"
                                [style.right.%]="100 - ((searchForm.get('maxValue')?.value - globalMin) / (globalMax - globalMin)) * 100">
                            </div>

                            <input type="range" class="range-input thumb-left" [min]="globalMin" [max]="globalMax"
                                [value]="searchForm.get('minValue')?.value" (input)="onMinSliderChange($event)" />

                            <input type="range" class="range-input thumb-right" [min]="globalMin" [max]="globalMax"
                                [value]="searchForm.get('maxValue')?.value" (input)="onMaxSliderChange($event)" />
                        </div>

                        <!-- INPUT BOXES -->
                        <div class="input-row">
                            <div class="input-box">
                                <span class="prefix">₹</span>
                                <input type="number" placeholder="Min" formControlName="minValue"
                                    (input)="validateMinMax($any($event.target).value, 'min')" />
                            </div>

                            <div class="dash">-</div>

                            <div class="input-box">
                                <span class="prefix">₹</span>
                                <input type="number" placeholder="Max" formControlName="maxValue"
                                    (input)="validateMinMax($any($event.target).value, 'max')" />
                            </div>
                        </div>

                        <!-- BUTTONS -->
                        <div class="button-row">
                            <button *ngIf="!selectedFilters.cleatBtnPrice" class="apply-btn"
                                (click)="applyPriceInput('price')">
                                Apply
                            </button>

                            <button *ngIf="selectedFilters.cleatBtnPrice" class="clear-btn" (click)="clearPriceInput()">
                                Clear
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Flavour Filter -->
                <div class="filter-section" *ngIf="flavoursArray.length > 0">
                    <h3 class="section-header" (click)="toggleSection('flavour')">Flavour
                        <i class="arrow-icon"
                            [ngClass]="isCollapsed.flavour ? 'fa fa-angle-down': 'fa fa-angle-up'"></i>
                    </h3>
                    <ul *ngIf="!isCollapsed.flavour">

                    </ul>
                </div>

                <!-- Food Type Filter -->
                <div class="filter-section">
                    <h3 class="section-header" (click)="toggleSection('foodType')">Food Type
                        <i class="arrow-icon"
                            [ngClass]="isCollapsed.foodType ? 'fa fa-angle-down' : 'fa fa-angle-up'"></i>

                    </h3>
                    <ul *ngIf="!isCollapsed.foodType">
                        <li *ngFor="let f of foodTypes;" class="filter-inner-section">
                            <mat-checkbox class="rounded-checkbox" (change)="onFoodTypeCheckBoxClick($event.checked, f)"
                                [checked]="isFilterChecked('foodTypes', f)">
                                {{f}}
                            </mat-checkbox>
                        </li>
                    </ul>
                </div>

                <!-- Offer Filter -->
                <div class="filter-section" *ngIf="offerTypeArray.length > 0">
                    <h3 class="section-header" (click)="toggleSection('offer')">Offers
                        <i class="arrow-icon" [ngClass]="isCollapsed.offer ? 'fa fa-angle-down': 'fa fa-angle-up'"></i>
                    </h3>
                    <ul *ngIf="!isCollapsed.offer">
                        <li *ngFor="let p of offerTypeArray" class="filter-inner-section">
                            <mat-checkbox class="rounded-checkbox" (change)="onOfferCheckBoxClick($event.checked, p)"
                                [checked]="isFilterChecked('offers', p)">
                                {{p}}
                            </mat-checkbox>
                        </li>
                    </ul>
                </div>

                <!-- Delivery With in Filter -->
                <div class="filter-section">
                    <h3 class="section-header" (click)="toggleSection('deliveryWithin')">Expected Delivery
                        <i class="arrow-icon"
                            [ngClass]="isCollapsed.deliveryWithin ? 'fa fa-angle-down': 'fa fa-angle-up'"></i>
                    </h3>
                    <ul *ngIf="!isCollapsed.deliveryWithin">
                        <li *ngFor="let option of deliveryWithinOptions" class="filter-inner-section">
                            <mat-checkbox class="rounded-checkbox"
                                (change)="ondeliveryWithinCheckBoxClick($event.checked, option)"
                                [checked]="isFilterChecked('deliveryWithin', option.value)">
                                {{option.label}}
                            </mat-checkbox>
                        </li>
                    </ul>
                </div>

                <!-- Group Filter -->
                <div class="filter-header">
                    <h3><i class="fa fa-cube"></i> Products</h3>
                </div>
                <div *ngFor="let group of makeToOrderGroupList">
                    <div class="filter-section">
                        <h3 class="section-header" (click)="group.collapsed = !group.collapsed">
                            {{group.productGroupName}}
                            <i class="arrow-icon" [ngClass]="group.collapsed ? 'fa fa-angle-up':'fa fa-angle-down'"></i>
                        </h3>
                        <ul *ngIf="group.collapsed">
                            <li *ngFor="let subGroup of group.subGroupList" class="filter-inner-section">
                                <mat-checkbox class="rounded-checkbox"
                                    (change)="onSubGroupChange($event.checked, subGroup.refNo)"
                                    [checked]="isFilterChecked('subGroupCodes', subGroup.refNo)">{{subGroup.productSubGroupName}}
                                </mat-checkbox>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div [ngClass]="openfilter ? 'display-container' : 'display-container display-bottom' ">
        <div class="display_holder" (click)="openfilter = !openfilter">
            <span class="display_detail">Filter
            </span>
            <mat-icon *ngIf="!openfilter" id="expand_more_icon">expand_less
            </mat-icon>
            <mat-icon *ngIf="openfilter" id="expand_less_icon">expand_more
            </mat-icon>
        </div>
    </div>

    <div class="container product_list_div" [ngClass]="openfilter ? 'display_none_small' : 'd-block' " *ngIf="show">
        <mat-icon class="sortbar_icon" [matMenuTriggerFor]="menu">filter_list</mat-icon>
        <mat-menu #menu="matMenu">
            <div class="sortbar_tabs_icon">
                <button class="sortbar_tab_btn" [ngClass]="{ 'sortbar_tab_btn_active': activeSort === 'lowToHigh' }"
                    type="button" (click)="sortProducts('lowToHigh')">Price: Low to
                    High</button>
                <button class="sortbar_tab_btn" [ngClass]="{ 'sortbar_tab_btn_active': activeSort === 'highToLow' }"
                    type="button" (click)="sortProducts('highToLow')">Price: High to
                    Low</button>
            </div>
        </mat-menu>
        <!-- <div *ngIf="selectedFilters.groupSubGroups.length > 0" class="sortbar_tabs_container">
            <div class="selected-filters">
                <div *ngFor="let subGroup of selectedFilters.groupSubGroups">
                    <span>{{ subGroup.productSubGroupName }}</span>
                    <button (click)="removeSubGroupFilter(subGroup.refNo)">x</button>
                </div>
            </div>
        </div> -->

        <div class="row">
            <cdk-virtual-scroll-viewport appendOnly itemSize="24" class="example-viewport" minBufferPx="1000"
                maxBufferPx="5000">
                <div class="col-md-12">
                    <div class="container div-style">
                        <app-card-loader [loop]="3" [height]="800" *ngIf="loading"></app-card-loader>
                        <div class="row" *ngIf="!loading">
                            <div class="col-lg-2 col-md-3 col-sm-3 col-xs-6" style="padding: 0;margin-bottom: 12px;"
                                *cdkVirtualFor="let product of productList | filterByBrand: selectedBrand;let i = index"
                                (click)="setRow(i)">
                                <div class="product-grid-wrapper">
                                    <div class="card card-cascade wider product-grid-item">
                                        <!--Card image-->
                                        <div class='product_image'>
                                            <img [src]="getImageUrl(product.product_Picture)"
                                                class='img-fluid pd_img_border' alt="Image not found" width="360px"
                                                height="300px"
                                                (error)="onImageError($event)"
                                                [routerLink]="['/make-product', generateSlug(product.product_Name) + '-' + product.product_Code]" />

                                            <div class="img_left_top">
                                                <div *ngIf="product.offers >= 1" class="offer_img_div"
                                                    (click)="viewOfferDetail(product.offerDetails)" matTooltip="Offers">
                                                    OFFER
                                                </div>

                                                <img *ngIf="product.food_Type == 'Veg'" class="food_type_align"
                                                    src="../../../../assets/img/Veg.webp" alt="" />
                                                <img *ngIf="product.food_Type == 'Non-Veg'" class="food_type_align"
                                                    src="../../../../assets/img/Nonveg.webp" alt="" />
                                            </div>

                                            <div class="img_right_top">
                                                <button type="button" class="img_right_bg" placement="top"
                                                    matTooltip="Add to Wishlist" container="body"
                                                    (click)="addFavourite(product)" aria-label="Action">
                                                    <i class="fa fa-heart" id="icon_align_pdl"></i>
                                                </button>

                                                <mat-icon class="img_right_bg" [matMenuTriggerFor]="menu"
                                                    id="icon_align_pdl" matTooltip="Share">share</mat-icon>
                                                <mat-menu #menu="matMenu">
                                                    <share-buttons theme="circles-dark"
                                                        [include]="['copy','whatsapp','facebook','email','telegram']"
                                                        [showIcon]="true" [showText]="false"
                                                        [url]="sharingUrl+product.product_Code"
                                                        [description]="product.product_Name" class="pt-5">
                                                    </share-buttons>
                                                </mat-menu>
                                            </div>
                                        </div>

                                        <div class="p-4">
                                            <h3 class="pdl_h3">
                                                <a [routerLink]="['/make-product', generateSlug(product.product_Name) + '-' + product.product_Code]"
                                                    routerLinkActive="router-link-active">
                                                    {{product.product_Name }}</a>
                                            </h3>
                                            <div class="pd_d_flex">
                                                <span class="pdl_price">₹ {{ product.net_Sale_Price | number:
                                                    "1.0"
                                                    }}</span>
                                                <span class="portion_weight">
                                                    {{product.portion_Weight ? product.portion_Weight : ' '}}
                                                </span>
                                            </div>
                                            <div *ngIf="product.deliveryLabel" class="delivery-info">
                                                Earliest Delivery: <span>{{ product.deliveryLabel }}</span>
                                            </div>
                                            <div class="pdl_btn_div">
                                                <button type="button" class="pdl_btn" style="width: 100%;"
                                                    [routerLink]="['/make-product', generateSlug(product.product_Name) + '-' + product.product_Code]">Buy
                                                    Now</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </cdk-virtual-scroll-viewport>
        </div>
    </div>
</div>